(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('[data-cart-page]').forEach((root) => {
    const stringsEl = document.querySelector('[data-cart-page-strings]');
    const strings = stringsEl ? JSON.parse(stringsEl.textContent) : {};
    const THRESHOLD = 99900;

    const formatMoney = (cents) =>
      new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(cents / 100);

    const setBusy = (line, busy) => {
      line.querySelectorAll('button').forEach((button) => {
        button.disabled = busy;
      });
    };

    const updateSummary = (cart) => {
      const subtotal = document.querySelector('[data-cart-subtotal]');
      if (subtotal) subtotal.textContent = formatMoney(cart.total_price);

      const count = document.querySelector('[data-cart-page-count]');
      if (count) count.textContent = cart.item_count;

      const headerBadge = document.querySelector('.header__cart-count');
      if (headerBadge) {
        headerBadge.textContent = cart.item_count;
        headerBadge.hidden = cart.item_count === 0;
      }

      const label = document.querySelector('[data-shipping-label]');
      const fill = document.querySelector('[data-shipping-fill]');
      if (label && fill) {
        const remaining = THRESHOLD - cart.total_price;
        if (remaining > 0) {
          label.textContent = (strings.remaining || '').replace('__AMOUNT__', formatMoney(remaining));
        } else {
          label.textContent = strings.unlocked || '';
        }
        fill.style.width = Math.min((cart.total_price / THRESHOLD) * 100, 100) + '%';
      }
    };

    const changeLine = (line, quantity) => {
      setBusy(line, true);

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.dataset.lineKey, quantity: quantity }),
      })
        .then((response) => {
          if (!response.ok) throw new Error('Cart update failed');
          return response.json();
        })
        .then((cart) => {
          if (cart.item_count === 0) {
            window.location.reload();
            return;
          }

          const item = cart.items.find((entry) => entry.key === line.dataset.lineKey);

          if (!item) {
            line.remove();
          } else {
            const qty = line.querySelector('[data-line-qty]');
            const total = line.querySelector('[data-line-total]');
            if (qty) qty.textContent = item.quantity;
            if (total) total.textContent = formatMoney(item.final_line_price);
            setBusy(line, false);
          }

          updateSummary(cart);
        })
        .catch(() => {
          setBusy(line, false);
        });
    };

    root.addEventListener('click', (event) => {
      const line = event.target.closest('[data-line-key]');
      if (!line) return;

      const step = event.target.closest('[data-step]');
      if (step) {
        const qtyEl = line.querySelector('[data-line-qty]');
        const current = parseInt(qtyEl.textContent, 10) || 0;
        const next = Math.max(current + parseInt(step.dataset.step, 10), 0);
        changeLine(line, next);
        return;
      }

      if (event.target.closest('[data-remove]')) {
        changeLine(line, 0);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.category-carousel').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const scrollAmount = () => track.clientWidth * 0.8;

    carousel.querySelector('[data-carousel-prev]').addEventListener('click', () => {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    carousel.querySelector('[data-carousel-next]').addEventListener('click', () => {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.category-tabs').forEach((section) => {
    const tabs = section.querySelectorAll('.category-tabs__tab');
    const panels = section.querySelectorAll('.category-tabs__panel');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((other) => {
          other.classList.remove('is-active');
          other.setAttribute('aria-selected', 'false');
        });
        panels.forEach((panel) => panel.classList.remove('is-active'));

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        section.querySelector('[data-panel="' + tab.dataset.tab + '"]').classList.add('is-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-account"]) return;
  try {
    
  (() => {
    const root = document.querySelector('.account');
    if (!root) return;

    const tabs = root.querySelectorAll('[data-account-tab]');
    const panels = root.querySelectorAll('[data-account-panel]');
    const names = Array.from(tabs).map((tab) => tab.dataset.accountTab);

    const activate = (name, updateHash) => {
      if (!names.includes(name)) return;
      tabs.forEach((tab) => {
        const active = tab.dataset.accountTab === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.accountPanel === name);
      });
      if (updateHash) history.replaceState(null, '', '#' + name);
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab.dataset.accountTab, true));
    });

    root.querySelectorAll('[data-account-goto]').forEach((button) => {
      button.addEventListener('click', () => {
        activate(button.dataset.accountGoto, true);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    root.querySelectorAll('.account__pagination a').forEach((link) => {
      link.href = link.href.split('#')[0] + '#orders';
    });

    const initial = window.location.hash.replace('#', '');
    if (initial) activate(initial, false);

    window.addEventListener('hashchange', () => {
      activate(window.location.hash.replace('#', ''), false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-addresses"]) return;
  try {
    
  (() => {
    const root = document.querySelector('.addresses');
    if (!root) return;

    root.querySelectorAll('[data-address-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const target = root.querySelector('[data-address-form="' + button.dataset.addressToggle + '"]');
        if (target) target.hidden = !target.hidden;
      });
    });

    root.querySelectorAll('form[data-address-delete]').forEach((form) => {
      form.addEventListener('submit', (event) => {
        if (!confirm(form.dataset.confirm)) event.preventDefault();
      });
    });

    root.querySelectorAll('[data-address-country]').forEach((countrySelect) => {
      const container = countrySelect.closest('form');
      if (!container) return;
      const provinceSelect = container.querySelector('[data-address-province]');
      const provinceWrapper = container.querySelector('[data-province-wrapper]');
      if (!provinceSelect || !provinceWrapper) return;

      const updateProvinces = (useDefault) => {
        const option = countrySelect.options[countrySelect.selectedIndex];
        let provinces = [];
        try {
          provinces = JSON.parse(option.getAttribute('data-provinces') || '[]');
        } catch (error) {
          provinces = [];
        }

        provinceSelect.innerHTML = '';

        if (!provinces.length) {
          provinceWrapper.hidden = true;
          return;
        }

        provinces.forEach((province) => {
          const provinceOption = document.createElement('option');
          provinceOption.value = province[0];
          provinceOption.textContent = province[1];
          provinceSelect.appendChild(provinceOption);
        });

        provinceWrapper.hidden = false;

        if (useDefault && provinceSelect.dataset.default) {
          provinceSelect.value = provinceSelect.dataset.default;
        }
      };

      const defaultCountry = countrySelect.dataset.default;
      if (defaultCountry) {
        Array.from(countrySelect.options).forEach((option) => {
          if (option.value === defaultCountry || option.textContent.trim() === defaultCountry) {
            option.selected = true;
          }
        });
      }

      updateProvinces(true);
      countrySelect.addEventListener('change', () => updateProvinces(false));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-login"]) return;
  try {
    
  (() => {
    const root = document.querySelector('.customers-login');
    if (!root) return;

    const loginCard = root.querySelector('[data-login-card]');
    const recoverCard = root.querySelector('[data-recover-card]');
    if (!loginCard || !recoverCard) return;

    const showRecover = (show) => {
      loginCard.hidden = show;
      recoverCard.hidden = !show;
      if (show) {
        window.location.hash = '#recover';
      } else if (window.location.hash === '#recover') {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    };

    root.querySelectorAll('[data-recover-open]').forEach((button) => {
      button.addEventListener('click', () => showRecover(true));
    });

    root.querySelectorAll('[data-recover-close]').forEach((button) => {
      button.addEventListener('click', () => showRecover(false));
    });

    if (window.location.hash === '#recover') showRecover(true);

    window.addEventListener('hashchange', () => {
      showRecover(window.location.hash === '#recover');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.header__drawer').forEach((drawer) => {
    const panel = drawer.querySelector('.header__drawer-panel');

    let closeTimer = null;

    const close = () => {
      if (drawer.classList.contains('is-closing')) return;
      drawer.classList.add('is-closing');

      const finishClose = () => {
        clearTimeout(closeTimer);
        panel.removeEventListener('animationend', onAnimationEnd);
        drawer.removeAttribute('open');
        drawer.classList.remove('is-closing');
      };

      const onAnimationEnd = (event) => {
        if (event.target !== panel) return;
        finishClose();
      };

      panel.addEventListener('animationend', onAnimationEnd);
      closeTimer = setTimeout(finishClose, 400);
    };

    drawer.querySelector('.header__drawer-close').addEventListener('click', close);
    drawer.querySelector('.header__drawer-overlay').addEventListener('click', close);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.hasAttribute('open')) {
        close();
      }
    });
  });

  // Hide the sticky header when scrolling down, reveal it when scrolling up
  (() => {
    const header = document.querySelector('.header');
    const section = header && header.closest('.shopify-section');
    if (!section) return;

    let lastY = window.scrollY;
    let ticking = false;
    const revealZone = 80;
    const deadzone = 5;

    const update = () => {
      const y = window.scrollY;
      if (y <= revealZone) {
        section.classList.remove('header--scrolled-down');
      } else if (y > lastY + deadzone) {
        section.classList.add('header--scrolled-down');
      } else if (y < lastY - deadzone) {
        section.classList.remove('header--scrolled-down');
      }
      lastY = y;
      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-carousel').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const scrollAmount = () => track.clientWidth * 0.8;

    carousel.querySelector('[data-carousel-prev]').addEventListener('click', () => {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    carousel.querySelector('[data-carousel-next]').addEventListener('click', () => {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const lightbox = document.querySelector('[data-review-lightbox]');
    if (!lightbox) return;
    const image = lightbox.querySelector('.product-reviews__lightbox-image');

    document.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-review-photo]');
      if (thumb) {
        image.src = thumb.dataset.full;
        lightbox.showModal();
        return;
      }

      if (!lightbox.open) return;

      if (event.target.closest('[data-review-lightbox-close]') || event.target === lightbox) {
        lightbox.close();
      }
    });

    lightbox.addEventListener('close', () => {
      image.src = '';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-testimonials]').forEach(function (section) {
      var openMedia = null;

      function closeMedia(media) {
        if (!media) return;
        var video = media.querySelector('video');
        if (video) {
          try { video.pause(); } catch (e) {}
          video.remove();
        }
        media.classList.remove('is-playing');
      }

      section.querySelectorAll('[data-testimonial-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var media = btn.closest('.testimonial__media');
          if (!media || media.classList.contains('is-playing')) return;

          // Solo un video a la vez.
          if (openMedia && openMedia !== media) closeMedia(openMedia);

          var tpl = media.querySelector('[data-testimonial-video]');
          if (!tpl) return;

          media.appendChild(tpl.content.cloneNode(true));
          media.classList.add('is-playing');
          openMedia = media;

          var video = media.querySelector('video');
          if (video) {
            video.setAttribute('playsinline', '');
            video.controls = true;
            var p = video.play();
            if (p && typeof p.catch === 'function') p.catch(function () {});
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('[data-product-main]').forEach((root) => {
    const dataEl = root.querySelector('[data-variant-data]');
    const variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    const variantMap = new Map();
    variants.forEach((variant) => variantMap.set(variant.options.join('::'), variant));

    const mainImage = root.querySelector('[data-main-image]');
    const thumbs = Array.from(root.querySelectorAll('[data-thumb]'));

    const watchImage = (img) => {
      if (!img || img.tagName !== 'IMG') return;
      const mark = () => img.classList.add('is-loaded');
      if (img.complete && img.naturalWidth > 0) {
        mark();
        return;
      }
      img.addEventListener('load', mark, { once: true });
      img.addEventListener('error', mark, { once: true });
    };

    root
      .querySelectorAll(
        '.product-gallery__image, .product-gallery__stack-image, .product-gallery__thumb-image, .product-lightbox__image, .product-lightbox__thumb-image'
      )
      .forEach(watchImage);

    const preloadStackImages = () => {
      root.querySelectorAll('.product-gallery__stack-image[loading="lazy"]').forEach((img) => {
        img.loading = 'eager';
      });
    };

    if (document.readyState === 'complete') {
      preloadStackImages();
    } else {
      window.addEventListener('load', preloadStackImages, { once: true });
    }
    const optionGroups = Array.from(root.querySelectorAll('[data-option-group]'));
    const priceEl = root.querySelector('[data-price]');
    const compareEl = root.querySelector('[data-compare-price]');
    const discountBadge = root.querySelector('[data-discount-badge]');
    const idInput = root.querySelector('[data-variant-id]');
    const buttons = Array.from(root.querySelectorAll('[data-add-button]'));
    const stockEl = root.querySelector('[data-stock]');
    const stockText = root.querySelector('[data-stock-text]');
    const quantityEl = root.querySelector('[data-quantity]');
    const buyNowBtn = root.querySelector('[data-buy-now]');
    const mainAddBtn = root.querySelector('.product-info__submit');
    const actionsEl = root.querySelector('.product-info__actions');
    const stickyBar = root.querySelector('[data-sticky-bar]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const stickyAddBtn = root.querySelector('[data-sticky-add]');
    const listPriceEl = root.querySelector('[data-list-price]');

    const updateStock = (variant) => {
      if (!stockEl || !stockText) return;
      if (!variant || !variant.inventory_managed || variant.inventory_quantity <= 0) {
        stockEl.hidden = true;
        return;
      }
      const low = variant.inventory_quantity <= 5;
      const template = low ? stockEl.dataset.labelLow : stockEl.dataset.labelAvailable;
      stockText.textContent = template.replace('__count__', variant.inventory_quantity);
      stockEl.classList.toggle('product-info__stock--low', low);
      stockEl.hidden = false;
    };

    const setMainImage = (src, srcset, imageId) => {
      if (!mainImage || !src) return;
      mainImage.classList.remove('is-loaded');
      mainImage.src = src;
      mainImage.srcset = srcset || '';
      if (imageId) mainImage.dataset.imageId = imageId;
      watchImage(mainImage);
    };

    const setActiveThumb = (active) => {
      thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb === active));
    };

    const lightbox = root.querySelector('[data-lightbox]');
    const openTrigger = root.querySelector('[data-open-lightbox]');
    const stackFrames = Array.from(root.querySelectorAll('[data-stack-frame]'));
    const isDesktop = window.matchMedia('(min-width: 750px)');
    const stackEl = root.querySelector('[data-gallery-swiper]');
    let gallerySwiper = null;

    const initialActiveThumb = thumbs.find((thumb) => thumb.classList.contains('is-active'));
    const initialImageId = initialActiveThumb ? initialActiveThumb.dataset.imageId : null;

    const syncThumbToIndex = (index) => {
      const frame = stackFrames[index];
      if (!frame) return;
      const active = thumbs.find((thumb) => thumb.dataset.imageId === frame.dataset.imageId);
      if (active) {
        setActiveThumb(active);
        active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
    };

    const initGallerySwiper = () => {
      if (gallerySwiper || isDesktop.matches) return;
      if (!stackEl || stackFrames.length < 2 || !window.Swiper) return;

      let initialIndex = 0;
      if (initialImageId) {
        const matchedIndex = stackFrames.findIndex((frame) => frame.dataset.imageId === initialImageId);
        if (matchedIndex >= 0) initialIndex = matchedIndex;
      }

      gallerySwiper = new window.Swiper(stackEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 350,
        threshold: 4,
        longSwipesRatio: 0.15,
        initialSlide: initialIndex,
      });
      gallerySwiper.on('slideChange', () => syncThumbToIndex(gallerySwiper.activeIndex));
      syncThumbToIndex(gallerySwiper.activeIndex);
    };

    const destroyGallerySwiper = () => {
      if (!gallerySwiper) return;
      gallerySwiper.destroy(true, true);
      gallerySwiper = null;
    };

    if (window.Swiper) {
      initGallerySwiper();
    } else {
      window.addEventListener('load', initGallerySwiper, { once: true });
    }

    if (isDesktop.matches && stackFrames.length > 0) {
      syncThumbToIndex(0);
    }

    isDesktop.addEventListener('change', (event) => {
      if (event.matches) {
        destroyGallerySwiper();
      } else {
        initGallerySwiper();
      }
    });

    const jumpToFrame = (frame) => {
      const index = stackFrames.indexOf(frame);
      if (gallerySwiper && !isDesktop.matches) {
        gallerySwiper.slideTo(index);
        syncThumbToIndex(index);
        return;
      }
      frame.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
    };

    if (lightbox) {
      const slides = Array.from(lightbox.querySelectorAll('[data-lightbox-slide]'));
      const lightboxThumbs = Array.from(lightbox.querySelectorAll('[data-lightbox-thumb]'));

      const setActiveLightboxThumb = (imageId) => {
        lightboxThumbs.forEach((thumb) => {
          const active = thumb.dataset.imageId === imageId;
          thumb.classList.toggle('is-active', active);
          if (active) thumb.scrollIntoView({ inline: 'center', block: 'nearest' });
        });
      };

      const openLightbox = (imageId) => {
        lightbox.showModal();
        const current = lightbox.querySelector('[data-lightbox-slide][data-image-id="' + imageId + '"]');
        const target = current || slides[0];
        if (target) {
          target.scrollIntoView({ inline: 'start', block: 'nearest' });
          setActiveLightboxThumb(target.dataset.imageId);
        }
      };

      if (openTrigger && mainImage) {
        openTrigger.addEventListener('click', () => openLightbox(mainImage.dataset.imageId));
      }

      stackFrames.forEach((frame) => {
        frame.addEventListener('click', () => openLightbox(frame.dataset.imageId));
      });

      lightbox.querySelector('[data-lightbox-close]').addEventListener('click', () => lightbox.close());

      lightboxThumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const slide = slides.find((item) => item.dataset.imageId === thumb.dataset.imageId);
          if (slide) slide.scrollIntoView({ inline: 'start', block: 'nearest', behavior: 'smooth' });
        });
      });

      const slideObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) setActiveLightboxThumb(entry.target.dataset.imageId);
          });
        },
        { root: lightbox.querySelector('[data-lightbox-track]'), threshold: 0.6 }
      );
      slides.forEach((slide) => slideObserver.observe(slide));

      lightbox.addEventListener('click', (event) => {
        const image = event.target.closest('.product-lightbox__image');
        if (image) {
          image.closest('[data-lightbox-slide]').classList.toggle('is-zoomed');
        }
      });

      lightbox.addEventListener('close', () => {
        lightbox.querySelectorAll('.is-zoomed').forEach((slide) => slide.classList.remove('is-zoomed'));
      });
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const frame = stackFrames.find((item) => item.dataset.imageId === thumb.dataset.imageId);
        if (frame) {
          jumpToFrame(frame);
          setActiveThumb(thumb);
          return;
        }
        setMainImage(thumb.dataset.src, thumb.dataset.srcset, thumb.dataset.imageId);
        setActiveThumb(thumb);
      });
    });


    if (stackFrames.length) {
      const frameObserver = new IntersectionObserver(
        (entries) => {
          if (gallerySwiper && !isDesktop.matches) return;
          entries.forEach((entry) => {
            if (!entry.isIntersecting || entry.intersectionRatio === 0) return;
            const active = thumbs.find((thumb) => thumb.dataset.imageId === entry.target.dataset.imageId);
            if (active) {
              setActiveThumb(active);
              active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
            }
          });
        },
        { rootMargin: '-40% 0px -40% 0px' }
      );
      stackFrames.forEach((frame) => frameObserver.observe(frame));
    }

    const srcsetFrom = (src) => {
      return [600, 900, 1200, 1600]
        .map((width) => src.replace(/([?&]width=)\d+/, '$1' + width) + ' ' + width + 'w')
        .join(', ');
    };

    const selectedValues = () => {
      return optionGroups.map((group) => {
        const select = group.querySelector('select');
        if (select) return select.value;
        const checked = group.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : '';
      });
    };

    const optionInputs = optionGroups.map((group) => Array.from(group.querySelectorAll('input[type="radio"]')));

    const updateAvailability = () => {
      const current = selectedValues();
      optionInputs.forEach((inputs, index) => {
        inputs.forEach((input) => {
          const combination = current.slice();
          combination[index] = input.value;
          const variant = variantMap.get(combination.join('::'));
          const label = input.closest('label');
          if (label) label.classList.toggle('is-unavailable', !variant || !variant.available);
        });
      });
    };

    const applyVariant = () => {
      updateAvailability();

      optionGroups.forEach((group) => {
        const label = group.querySelector('[data-option-value-label]');
        const checked = group.querySelector('input[type="radio"]:checked');
        if (label && checked) label.textContent = checked.value;
      });

      const variant = variantMap.get(selectedValues().join('::'));

      if (!variant) {
        buttons.forEach((button) => {
          button.disabled = true;
          button.textContent = button.dataset.labelUnavailable;
        });
        if (buyNowBtn) buyNowBtn.disabled = true;
        updateStock(null);
        return;
      }

      updateStock(variant);

      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price;
      if (stickyPrice) stickyPrice.textContent = variant.price;
      if (buyNowBtn) buyNowBtn.disabled = !variant.available;

      if (compareEl && listPriceEl) {
        if (variant.compare_at_price) {
          compareEl.textContent = variant.compare_at_price;
          listPriceEl.hidden = false;
        } else {
          listPriceEl.hidden = true;
        }
      }

      if (discountBadge) {
        if (variant.compare_cents && variant.compare_cents > variant.price_cents) {
          const percent = Math.round((1 - variant.price_cents / variant.compare_cents) * 100);
          discountBadge.textContent = '-' + percent + '%';
          discountBadge.hidden = false;
        } else {
          discountBadge.hidden = true;
        }
      }

      buttons.forEach((button) => {
        button.disabled = !variant.available;
        button.textContent = variant.available ? button.dataset.labelAdd : button.dataset.labelUnavailable;
      });

      if (variant.image) {
        const frame = stackFrames.find((item) => item.dataset.imageId === String(variant.image_id));
        if (frame) {
          jumpToFrame(frame);
        }

        const matching = thumbs.find((thumb) => thumb.dataset.imageId === String(variant.image_id));
        if (matching) {
          setMainImage(matching.dataset.src, matching.dataset.srcset, matching.dataset.imageId);
          setActiveThumb(matching);
        } else {
          setMainImage(variant.image, srcsetFrom(variant.image), variant.image_id);
        }
      }
    };

    optionGroups.forEach((group) => group.addEventListener('change', applyVariant));

    const getQuantity = () => {
      const q = quantityEl ? parseInt(quantityEl.value, 10) : 1;
      return q && q > 0 ? q : 1;
    };

    // "Comprar ahora": add to cart via AJAX, then jump straight to checkout
    if (buyNowBtn && idInput) {
      const buyNowLabel = buyNowBtn.textContent;

      // Restore the button to its real state (label + availability). Needed
      // because when the user hits "back" the page is served from the browser's
      // bfcache with the button frozen in its "…"/disabled loading state.
      const resetBuyNow = () => {
        buyNowBtn.textContent = buyNowLabel;
        buyNowBtn.disabled = mainAddBtn ? mainAddBtn.disabled : false;
      };

      window.addEventListener('pageshow', (event) => {
        if (event.persisted) resetBuyNow();
      });

      buyNowBtn.addEventListener('click', () => {
        if (buyNowBtn.disabled) return;
        buyNowBtn.disabled = true;
        buyNowBtn.textContent = '…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: idInput.value, quantity: getQuantity() }),
        })
          .then((response) => {
            if (!response.ok) throw new Error('add-to-cart failed');
            return response.json();
          })
          .then(() => {
            window.location.href = '/checkout';
          })
          .catch(resetBuyNow);
      });
    }

    // Sticky mobile bar mirrors the main add-to-cart and appears when it scrolls away
    if (stickyAddBtn && mainAddBtn) {
      stickyAddBtn.addEventListener('click', () => mainAddBtn.click());
    }

    if (stickyBar && actionsEl && 'IntersectionObserver' in window) {
      const barObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      });
      barObserver.observe(actionsEl);
    }

    // Offer countdown timer
    const countdown = root.querySelector('[data-countdown]');
    if (countdown) {
      const timeEl = countdown.querySelector('[data-countdown-time]');
      const endTime = new Date(countdown.dataset.end).getTime();
      const pad = (n) => String(n).padStart(2, '0');
      let timer;
      const tick = () => {
        const diff = endTime - Date.now();
        if (isNaN(endTime) || diff <= 0) {
          countdown.hidden = true;
          if (timer) clearInterval(timer);
          return;
        }
        const totalSec = Math.floor(diff / 1000);
        const days = Math.floor(totalSec / 86400);
        const hours = Math.floor((totalSec % 86400) / 3600);
        const mins = Math.floor((totalSec % 3600) / 60);
        const secs = totalSec % 60;
        timeEl.textContent = (days > 0 ? days + 'd ' : '') + pad(hours) + ':' + pad(mins) + ':' + pad(secs);
        countdown.hidden = false;
      };
      tick();
      timer = setInterval(tick, 1000);
    }

    // Copy the discount code to the clipboard (swaps the copy icon for a check)
    const promoCode = root.querySelector('[data-copy-code]');
    if (promoCode) {
      let copyTimer;
      const showCopied = () => {
        promoCode.classList.add('is-copied');
        clearTimeout(copyTimer);
        copyTimer = setTimeout(() => promoCode.classList.remove('is-copied'), 1600);
      };
      promoCode.addEventListener('click', () => {
        const code = promoCode.dataset.copyCode;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(code).then(showCopied).catch(showCopied);
        } else {
          showCopied();
        }
      });
    }

    updateAvailability();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.video-carousel').forEach((carousel) => {
    const track = carousel.querySelector('[data-carousel-track]');
    const scrollAmount = () => track.clientWidth * 0.8;

    carousel.querySelector('[data-carousel-prev]').addEventListener('click', () => {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });

    carousel.querySelector('[data-carousel-next]').addEventListener('click', () => {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-feed"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-video-feed]').forEach((feed) => {
    const track = feed.querySelector('[data-carousel-track]');
    const prev = feed.querySelector('[data-carousel-prev]');
    const next = feed.querySelector('[data-carousel-next]');
    const scrollAmount = () => track.clientWidth * 0.8;

    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));

    const carouselObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.play().catch(() => {});
          } else {
            entry.target.pause();
          }
        });
      },
      { threshold: 0.35 }
    );
    track.querySelectorAll('video').forEach((video) => carouselObserver.observe(video));

    const dialog = feed.querySelector('[data-feed-dialog]');
    if (!dialog) return;

    const scroller = dialog.querySelector('[data-feed-scroller]');
    const slides = Array.from(dialog.querySelectorAll('[data-feed-slide]'));

    const stopAll = () => {
      slides.forEach((slide) => {
        const video = slide.querySelector('video');
        if (video) {
          video.pause();
          video.muted = true;
        }
      });
    };

    const activate = (video) => {
      if (!video) return;
      video.muted = false;
      const attempt = video.play();
      if (attempt && attempt.catch) {
        attempt.catch(() => {
          video.muted = true;
          video.play().catch(() => {});
        });
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target.querySelector('video');
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
            activate(video);
          } else if (video) {
            video.pause();
            video.muted = true;
          }
        });
      },
      { root: scroller, threshold: [0.6] }
    );

    feed.querySelectorAll('[data-feed-open]').forEach((item) => {
      item.addEventListener('click', () => {
        const index = Number(item.dataset.index) || 0;
        dialog.showModal();
        slides.forEach((slide) => observer.observe(slide));
        const target = slides[index];
        if (target) target.scrollIntoView({ block: 'start', behavior: 'instant' });
      });
    });

    dialog.addEventListener('close', () => {
      slides.forEach((slide) => observer.unobserve(slide));
      stopAll();
    });

    const closeButton = dialog.querySelector('[data-feed-close]');
    if (closeButton) closeButton.addEventListener('click', () => dialog.close());
  });

  } catch(e) { console.error(e); }
})();
})();
